import { moduleNames } from "data/enums/modules";
import { enumPermissionModules as EPM, enumPermissions as EP } from "../enums/authorization";

const enumTranslations = {
  spreadsheetsType: {
    "employee-payment-trimester": "Déduction - CCT",
    "employee-tax-deduction": "Déduction des impôts à la source",
    "planner": "Planificateur",
    "employee-annual-sheet": "Décomptes des heures mensuelles - annuelles",
  },
  spreadsheetsStatus: {
    1: "En attente",
    2: "Créé",
    9: "Supprimé"
  },
  workingSiteStatus: {
    1: "Actif",
    2: "Inactif"
  },
  reccurenceType: {
    daily: "Quotidien",
    weekly: "Hebdomadaire",
    monthly: "Mensuel",
    annually: "Annuel",
    every_2_weeks: "Toutes les 2 semaines",
    every_3_weeks: "Toutes les 3 semaines"
  },
  dayOfWeek: {
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche"
  },
  weekOfMonth: {
    first: "Premier",
    second: "Deuxième",
    third: "Troisième",
    fourth: "Quatrième",
    last: "Dernier"
  },
  interval: {
    1: '1',
    2: '2',
    3: '3'
  },
  duration: {
    "this-week": "Cette semaine",
    "this-month": "Ce mois",
    "this-year": "Cette année",
    "unlimited": "Illimité"
  },
  taxEmployeesStatus: {
    1: "En attente",
    2: "Créé",
    9: "Supprimé"
  },
  taxEmployeesTrimester: {
    1: 'Janvier-Février-Mars',
    2: 'Avril-Mai-Juin',
    3: 'Juillet-Août-Septembre',
    4: 'Octobre-Novembre-Décembre'
  },
  workingHoursSubmissionsStatus: {
    2: 'Approuvé',
    3: 'Rejeté',
    1: 'En attente',
    default: 'Inconnu'
  },
  employeesNumberOfchildren: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    default: "Inconnu",
  },
  employeeJobType: {
    "flex-site": 'Temps complet',
    "fixed-site": 'Temps partiel',
    default: "Inconnu",
  },
  employeesSex: {
    male: 'Mâle',
    female: 'Femelle',
    default: "Inconnu",
  },
  employeesHasChildren: {
    yes: 'Oui',
    no: 'Non',
    default: "Inconnu",
  },
  taxScalesGroups: {
    A: 'A',
    B: 'B',
    C: 'C',
    H: 'H',
    default: "Inconnu",
  },
  formsTemplatesStatus: {
    default: "Inconnu",
    active: "Actif",
    deleted: "Supprimé",
  },
  formsTemplatesExpires: {
    default: "Inconnu",
    daily: "Quotidien",
    weekly: "Hebdomadaire",
    annually: "Annuel",
    'no-limit': 'Aucune limite'
  },
  formsTemplatesTarget: {
    employees: "Employés",
    partners: "Partenaires",
    public: "Public",
    default: "Inconnu",
  },
  usersStatus: {
    1: 'Admin',
    2: 'Responsable de compte',
    9: 'Kurir',
    99: 'Banni'
  },
  employeesStatus: {
    default: "Inconnu",
    1: "Actif",
    2: "Inactif",
    3: "En attente d'inscription",
    4: "En attente de validation",
    9: 'Supprimé'
  },
  employeesReligion: {
    default: "Inconnu",
    agnostic: "Agnostique",
    muslim: "Musulman",
    christian: 'Chrétien',
    jewish: 'Juif',
    atheist: 'Athée',
  },
  cities: {
    default: "Unknown",
    zurich: "Zurich",
    geneva: "Geneva",
    basel: "Basel",
    lausanne: "Lausanne",
    bern: "Bern",
    winterthur: "Winterthur",
    lucerne: "Lucerne",
    st_gallen: "St. Gallen",
    lugano: "Lugano",
    biel_bienne: "Biel/Bienne",
    thun: "Thun",
    koniz: "Köniz",
    la_chaux_de_fonds: "La Chaux-de-Fonds",
    fribourg: "Fribourg",
    schaffhausen: "Schaffhausen",
  },
  languages: {
    fr: 'Français',
    de: 'Allemand',
    en: 'Anglais',
    rm: 'Romanche'
  },
  taxCantons: {
    default: "Unknown",
    aargau: "Aargau",
    appenzell_ausserrhoden: "Appenzell Ausserrhoden",
    appenzell_innerrhoden: "Appenzell Innerrhoden",
    basel_landschaft: "Basel-Landschaft",
    basel_stadt: "Basel-Stadt",
    bern: "Bern",
    fribourg: "Fribourg",
    geneva: "Geneva",
    glarus: "Glarus",
    graubunden: "Graubünden",
    jura: "Jura",
    lucerne: "Lucerne",
    neuchatel: "Neuchâtel",
    nidwalden: "Nidwalden",
    obwalden: "Obwalden",
    schaffhausen: "Schaffhausen",
    schwyz: "Schwyz",
    solothurn: "Solothurn",
    st_gallen: "St. Gallen",
    thurgau: "Thurgau",
    ticino: "Ticino",
    uri: "Uri",
    valais: "Valais (Wallis)",
    vaud: "Vaud",
    zug: "Zug",
    zurich: "Zurich",
  },
  employeesMaritalStatus: {
    default: "Inconnu",
    single: "Célibataire",
    married: "Marié",
    divorced: 'Divorcé',
    widowed: 'Veuf/Veuve',
    separated: 'Séparé',
    registered_partnership: 'Partenariat enregistré',
    partnership_resolved_by_right: 'Partenariat résolu de plein droit',
    partnership_dissolved_due_to_death: 'Partenariat dissous pour cause de décès',
    partnership_dissolved_due_to_declaration_of_absence: 'Partenariat dissous pour cause de déclaration d\'absence',
    unknown: 'Inconnu'
  },
  workingHoursComments: {
    vacancy: 'Vacances',
    leave: 'Congés',
    'public-holidays': 'Jours férié',
    diseases: 'Maladies',
    accidents: 'Accident',
    default: 'Inconnu'
  },
  employeesSalaryType: {
    hourly: 'À l\'heure',
    monthly: 'Mensuel',
    default: 'Inconnu'
  },
  employeesWorkingPermit: {
    'L - short time': 'L - Permis de courte durée',
    'A - short time': 'A - Permis de courte durée',
    'B - annual': 'B - Permis annuel',
    'C - of establishment': 'C - Permis d\'établissement',
    'G - border': 'G - frontalier',
    'N - asylum seeker': 'N - Requérant d\'asile',
    'S - people of protect': 'S - Personnes à protéger',
    'Other': 'Autres',
    'Swisse': 'Swisse',
    default: 'Inconnu'
  },
  booleanYesNo: {
    default: "Non",
    yes: "Oui",
    no: "Non",
  },
  booleanNumber: {
    default: "Non",
    1: "Oui",
    0: "Non",
  },
}

const commonTableFilters = {
  filter: "Filtres",
  search: "Rechercher des filtres",
  filterTypes: {
    dateRange: {
      label: "Plage de dates",
      helperText: "La valeur représente la date du serveur",
      invalidRange: ": plage invalide",
      maxDate: ": date maximale dépassée",
      minDate: ": date minimale dépassée",
    },
    selectStaticMultiple: {
      placeholder: "Sélectionner",
      noOptionsText: "Aucune option disponible",
      select: "Sélectionner",
    },
    selectStaticSingle: {
      placeholder: "Sélectionner",
      noOptionsText: "Aucune option disponible",
    },
    countrySelect: {
      placeholder: "Sélectionner le pays",
    },
    selectAjaxMultiple: {
      text: "Aucune option disponible",
      placeholder: "Rechercher",
      loading: "Chargement",
    },
  },
  sortAsc: "Trier la colonne par ordre croissant",
  sortDesc: "Trier la colonne par ordre décroissant",
  hideColumn: "Masquer la colonne",
  clearStickyColumn: "Effacer la colonne collante",
  setStickyColumn: "Définir la colonne collante",
  clearStickyRow: "Effacer la ligne collante",
  setStickyRow: "Définir la ligne collante",
  noData: "Aucune donnée",
  pinColumnLeft: "Épingler la colonne à gauche",
  pinColumnRight: "Épingler la colonne à droite",
  unpinColumn: "Détacher la colonne",
};

const commonModalTranslations = {
  required: 'Requis',
  affectedRows: "Lignes affectées",
  itemSelectedForBulk: "Article sélectionné pour la vente en gros",
  create: "Créer",
  noItemsSelectedForAddConstant: "Aucun élément sélectionné pour ajouter une constante",
  add: "Ajouter",
  row: "rangée",
  month: "mois",
  footer: {
    reset: "Réinitialiser",
    cancel: "Annuler",
    submit: "Soumettre",
    serverMessage: "Message du serveur"
  },
  body: {
    warning: "Cette action ne peut pas être annulée !",
    question: "Êtes-vous sûr de vouloir supprimer ",
    noItems: "Aucun élément sélectionné pour la suppression en masse",
    isLoading: "Suppression en cours",
    isSuccess: "Supprimé avec succès",
    isError: "Erreur lors de la suppression",
    itemSelected: "Élément sélectionné pour la suppression en masse",
  },
  filepond: {
    labelIdle: "Glissez et déposez vos fichiers ou <span class='filepond--label-action'> Parcourir </span>",
    labelInvalidField: "Champ contenant des fichiers non valides",
    labelFileProcessing: "Chargement en cours",
    labelFileRemoveError: "Erreur lors de la suppression",
    labelFileLoadError: "Erreur lors du chargement",
    labelTapToCancel: "Appuyez pour annuler",
    labelFileProcessingComplete: "Chargement terminé",
    labelFileProcessingAborted: "Chargement annulé",
    labelButtonProcessItem: "Téléverser",
    labelButtonRetryItemProcessing: "Réessayer",
    labelButtonAbortItemProcessing: "Annuler",
    labelButtonUndoItemProcessing: "Annuler l'opération",
    labelTapToUndo: 'Appuyez pour annuler',
    labelFileLoading: 'Chargement'
  }
};

const commonTableTranslations = {
  header: {
    filters: "Filtres",
    sortAsc: "Trier par ordre croissant",
    sortDesc: "Trier par ordre décroissant",
    all: "Tous",
    refreshData: "Actualiser les données",
    columnsEditor: "Éditeur de colonnes",
    visualLayers: "Couches visuelles",
    emptySpace: "Remplir l'espace vide de la table",
    bulkOptions: "Options groupées",
    orderColumns: "Sélectionner ou réorganiser les colonnes de la table",
    enable: "Activer le remplissage automatique lors du redimensionnement de l'écran",
    disable: "Désactiver le remplissage automatique lors du redimensionnement de l'écran",
  },
  body: {
    pinRow: "Épingler la ligne",
  },
};

const modalFieldsErrors = {
  required: 'Requis',
  minimum: `minimum {minChar} caractères`,
  maximum: `maximum {maxChar} caractères`,
  min: `min autorisé {min}`,
  max: 'max autorisé {max}',
  email: 'format incorrect',
  domain: 'format incorrect (http/https)://domain.com)',
  fieldsDontMatch: "le champ ne correspond pas à {matchFieldLabel}"
}

const FR = {
  modalFieldsErrors,
  MenuSegment: {
    admin: 'Admin',
    user: 'User',
    system: 'System',
    dev: 'Dev'
  },
  Navbar: {
    profile: 'Profil',
    logout: 'Déconnexion'
  },
  Footer: {
    confirm: 'Confirmer',
    logout: 'Déconnexion'
  },
  MenuLink: {
    [moduleNames.ADMIN_HOME]: 'Accueil',
    [moduleNames.ADMIN_USERS]: 'Utilisateurs',
    [moduleNames.ADMIN_EMPLOYEES]: 'Employés',
    [moduleNames.ADMIN_EMPLOYEES_ABSENCE]: 'Absence des employés',
    [moduleNames.ADMIN_EMPLOYEES_NOTES]: 'Notes des employés',
    [moduleNames.ADMIN_LOGIN_HISTORY]: 'Historique de connexion',
    [moduleNames.ADMIN_FORMS_DROPDOWN]: 'Formulaires',
    [moduleNames.ADMIN_FORMS_TEMPLATES]: 'Modèles',
    [moduleNames.ADMIN_COMPANIES]: 'Companies',
    [moduleNames.ADMIN_FORMS_SUBMISSIONS]: 'Soumissions',
    [moduleNames.ADMIN_WORKING_SITES]: 'Chantiers',
    [moduleNames.ADMIN_WORKING_SITES_PLANNER]: 'Planificateur',
    [moduleNames.ADMIN_WORKING_HOURS_DROPDOWN]: 'Heures de travail',
    [moduleNames.ADMIN_WORKING_HOURS]: 'Annuel',
    [moduleNames.ADMIN_WORKING_HOURS_SUBMISSIONS]: 'Soumissions',
    [moduleNames.ADMIN_CANTONS]: 'Cantons',
    [moduleNames.ADMIN_CANTONS_HOLIDAYS]: 'Vacances des cantons',
    [moduleNames.ADMIN_COMMUNE]: 'Communes',
    [moduleNames.ADMIN_CITIES]: 'Villes',
    [moduleNames.ADMIN_TAX_SCALES]: 'Barèmes',
    [moduleNames.ADMIN_TAX_EMPLOYEES]: 'Décompte fiscal',
    [moduleNames.ADMIN_TAX_SCALES_DETAILS]: 'Barèmes dètails',
    [moduleNames.ADMIN_PROFILE]: 'Profil',
    [moduleNames.ADMIN_GROUPS]: 'Groupes',
    [moduleNames.ADMIN_REPORT]: 'Rapport',
    [moduleNames.ADMIN_REPORT_EMPLOYEES]: 'Employés',
    [moduleNames.ADMIN_REPORT_WORKING_SITES]: 'Chantiers',
    [moduleNames.ADMIN_REPORT_WORK_TABLE]: 'Pivot',
    [moduleNames.ADMIN_SPREADSHEETS]: 'Feuiles',

    [`${moduleNames.DEV_BUILDER_DROPDOWN}_admin`]: 'Constructeur',
    [`${moduleNames.DEV_BUILDER_MODULE}_admin`]: 'Module',
  },
  PermissionsModalBody: {
    admin: 'Admin',
    [EPM.ADMIN_USERS]: 'Utilisateurs',
    [EP.ADMIN_USERS_LIST]: 'Liste',
    [EP.ADMIN_USERS_CREATE]: 'Créer',
    [EP.ADMIN_USERS_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_USERS_DELETE]: 'Supprimer',

    [EPM.ADMIN_COMPANIES]: 'Entreprises',
    [EP.ADMIN_COMPANIES_LIST]: 'Lister',
    [EP.ADMIN_COMPANIES_CREATE]: 'Créer',
    [EP.ADMIN_COMPANIES_UPDATE]: 'Modifier',
    [EP.ADMIN_COMPANIES_DELETE]: 'Supprimer',

    [EPM.ADMIN_EMPLOYEES]: 'Employés',
    [EP.ADMIN_EMPLOYEES_LIST]: 'Liste',
    [EP.ADMIN_EMPLOYEES_CREATE]: 'Créer',
    [EP.ADMIN_EMPLOYEES_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_EMPLOYEES_DELETE]: 'Supprimer',
    [EP.ADMIN_EMPLOYEES_FILES]: 'Des dossiers',
    [EP.ADMIN_EMPLOYEES_IMAGE]: 'Image',

    [EPM.ADMIN_EMPLOYEES_NOTES]: "Notes des employés",
    [EP.ADMIN_EMPLOYEES_NOTES_LIST]: "Liste",
    [EP.ADMIN_EMPLOYEES_NOTES_CREATE]: "Créer",
    [EP.ADMIN_EMPLOYEES_NOTES_UPDATE]: "Mettre à jour",
    [EP.ADMIN_EMPLOYEES_NOTES_DELETE]: "Supprimer",

    [EPM.ADMIN_EMPLOYEES_ABSENCE]: 'Absence des employés',
    [EP.ADMIN_EMPLOYEES_ABSENCE_LIST]: 'Liste',
    [EP.ADMIN_EMPLOYEES_ABSENCE_CREATE]: 'Créer',
    [EP.ADMIN_EMPLOYEES_ABSENCE_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_EMPLOYEES_ABSENCE_DELETE]: 'Supprimer',

    [EPM.ADMIN_SPREADSHEETS]: 'Feuiles',
    [EP.ADMIN_SPREADSHEETS_LIST]: 'Liste',
    [EP.ADMIN_SPREADSHEETS_CREATE]: 'Créer',
    [EP.ADMIN_SPREADSHEETS_DELETE]: 'Supprimer',

    [EPM.ADMIN_REPORT]: 'Rapport',
    [EP.ADMIN_REPORT_EMPLOYEES]: 'Employés',
    [EP.ADMIN_REPORT_WORKING_SITES]: 'Chantiers',
    [EP.ADMIN_REPORT_WORK_TABLE]: 'Pivot',

    [EPM.ADMIN_CANTONS]: 'Cantons',
    [EP.ADMIN_CANTONS_LIST]: 'Liste',
    [EP.ADMIN_CANTONS_CREATE]: 'Créer',
    [EP.ADMIN_CANTONS_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_CANTONS_DELETE]: 'Supprimer',

    [EPM.ADMIN_TAX_SCALES]: 'Barèmes',
    [EP.ADMIN_TAX_SCALES_LIST]: 'Liste',
    [EP.ADMIN_TAX_SCALES_CREATE]: 'Créer',
    [EP.ADMIN_TAX_SCALES_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_TAX_SCALES_DUPLICATE]: 'Dupliquer',

    [EPM.ADMIN_TAX_SCALES_DETAILS]: 'Barèmes dètails',
    [EP.ADMIN_TAX_SCALES_DETAILS_LIST]: 'Liste',
    [EP.ADMIN_TAX_SCALES_DETAILS_CREATE]: 'Créer',
    [EP.ADMIN_TAX_SCALES_DETAILS_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_TAX_SCALES_DETAILS_DELETE]: 'Supprimer',

    [EPM.ADMIN_TAX_EMPLOYEES]: 'Décompte fiscal',
    [EP.ADMIN_TAX_EMPLOYEES_LIST]: 'Liste',
    [EP.ADMIN_TAX_EMPLOYEES_CREATE]: 'Créer',
    [EP.ADMIN_TAX_EMPLOYEES_GET]: 'Obtenir',

    [EPM.ADMIN_CANTONS_HOLIDAYS]: 'Vacances des cantons',
    [EP.ADMIN_CANTONS_HOLIDAYS_LIST]: 'Liste',
    [EP.ADMIN_CANTONS_HOLIDAYS_CREATE]: 'Créer',
    /* [EP.ADMIN_CANTONS_HOLIDAYS_UPDATE]: 'Mettre à jour', */
    [EP.ADMIN_CANTONS_HOLIDAYS_DELETE]: 'Supprimer',

    [EPM.ADMIN_COMMUNE]: 'Communes',
    [EP.ADMIN_COMMUNE_LIST]: 'Liste',
    [EP.ADMIN_COMMUNE_CREATE]: 'Créer',
    [EP.ADMIN_COMMUNE_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_COMMUNE_DELETE]: 'Supprimer',

    [EPM.ADMIN_CITIES]: 'Villes',
    [EP.ADMIN_CITIES_LIST]: 'Liste',
    [EP.ADMIN_CITIES_CREATE]: 'Créer',
    [EP.ADMIN_CITIES_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_CITIES_DELETE]: 'Supprimer',

    [EPM.ADMIN_PERMISSIONS]: 'Permissions',
    [EP.ADMIN_PERMISSIONS_GET]: 'Obtenir',
    [EP.ADMIN_PERMISSIONS_UPDATE]: 'Mettre à jour',

    [EPM.ADMIN_FORMS_TEMPLATES]: 'Modèles de formulaires',
    [EP.ADMIN_FORMS_TEMPLATES_LIST]: 'Liste',
    [EP.ADMIN_FORMS_TEMPLATES_CREATE]: 'Créer',
    [EP.ADMIN_FORMS_TEMPLATES_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_FORMS_TEMPLATES_DELETE]: 'Supprimer',
    [EP.ADMIN_FORMS_TEMPLATES_GET_LINK]: 'Obtenir le lien',

    [EPM.ADMIN_FORMS_SUBMISSIONS]: 'Soumissions de formulaires',
    [EP.ADMIN_FORMS_SUBMISSIONS_LIST]: 'Liste',
    [EP.ADMIN_FORMS_SUBMISSIONS_GET]: 'Obtenir',

    [EPM.ADMIN_WORKING_SITES]: 'Sites de travail',
    [EP.ADMIN_WORKING_SITES_LIST]: 'Liste',
    [EP.ADMIN_WORKING_SITES_CREATE]: 'Créer',
    [EP.ADMIN_WORKING_SITES_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_WORKING_SITES_DELETE]: 'Supprimer',

    [EPM.ADMIN_WORKING_SITES_PLANNER]: 'Planificateur',
    [EP.ADMIN_WORKING_SITES_PLANNER_LIST]: 'Liste',
    [EP.ADMIN_WORKING_SITES_PLANNER_CREATE]: 'Créer',
    [EP.ADMIN_WORKING_SITES_PLANNER_CREATE_CONSTANT]: 'Créer une constante',
    [EP.ADMIN_WORKING_SITES_PLANNER_GET]: 'Obtenir',
    [EP.ADMIN_WORKING_SITES_PLANNER_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_WORKING_SITES_PLANNER_DELETE]: 'Supprimer',

    [EPM.ADMIN_EMPLOYEES_PLANNER]: 'Filtre du planificateur d\'employés',
    [EP.ADMIN_EMPLOYEES_PLANNER_LIST]: 'Liste',

    [EPM.ADMIN_WORKING_HOURS]: 'Heures de travail annuelles',
    [EP.ADMIN_WORKING_HOURS_LIST]: 'Liste',
    [EP.ADMIN_WORKING_HOURS_GET]: 'Obtenir',
    [EP.ADMIN_WORKING_HOURS_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_WORKING_HOURS_CREATE]: 'Créer',
    [EP.ADMIN_WORKING_HOURS_TOTALS]: 'Totale',

    [EPM.ADMIN_WORKING_HOURS_SUBMISSIONS]: 'Soumissions d\'heures de travail',
    [EP.ADMIN_WORKING_HOURS_SUBMISSIONS_LIST]: 'Liste',
    [EP.ADMIN_WORKING_HOURS_SUBMISSIONS_GET]: 'Obtenir',
    [EP.ADMIN_WORKING_HOURS_SUBMISSIONS_UPDATE]: 'Mettre à jour',

    [EPM.ADMIN_GROUPS]: 'Groupes',
    [EP.ADMIN_GROUPS_LIST]: 'Liste',
    [EP.ADMIN_GROUPS_CREATE]: 'Créer',
    [EP.ADMIN_GROUPS_UPDATE]: 'Mettre à jour',
    [EP.ADMIN_GROUPS_DELETE]: 'Supprimer',

    common: 'Common',
    [EPM.SETTINGS]: 'Paramètres',
    [EP.SETTINGS_GET]: 'Obtenir',
    [EP.SETTINGS_UPDATE]: 'Mettre à jour',
  },
  DashboardFooter: {
    companyName: 'CRM', /* SHOULD_CHANGE */
    craftedLeft: 'Crafted with',
    craftedRight: 'by Damir&Nadir' /* SHOULD_CHANGE */
  },
  Logout: {
    title: 'Logout',
    loading: 'Waiting to safely log out',
    completed: 'You have been safely logged out',
    button: 'Back to Login'
  },
  RequestErrors: {
    default: 'Erreur inconnue',
    browser: {
      ERR_NETWORK: 'Erreur réseau'
    },
    network: {
      401: 'Utilisateur non authentifié',
      403: 'Permissions insuffisantes',
      405: 'Méthode non autorisée',
      406: 'Requête non acceptable'
    },
    internal: {
      1: 'La méthode demandée n\'est pas autorisée',
      2: 'Les informations de connexion n\'ont pas été transmises',
      3: 'Le nom d\'utilisateur est au format invalide',
      4: 'Le mot de passe est au format invalide',
      5: 'Les données de connexion ne sont pas valides',
      6: 'Erreur de base de données',
      7: 'La requête POST est au format incorrect',
      8: 'Le champ est au format incorrect',
      9: 'L\'entrée existe déjà dans la base de données',
      10: 'L\'ID doit être transmis par la méthode GET',
      11: 'L\'ID demandé n\'a pas été trouvé dans la base de données',
      12: 'Un des paramètres de recherche doit être transmis. [id]',
      13: 'Le paramètre GET est au format invalide',
      14: 'L\'utilisateur demandé n\'a pas été trouvé dans la base de données',
      15: 'Le pays demandé n\'a pas été trouvé dans la base de données',
      16: "L'utilisateur n'a pas la permission pour le module / action demandé(e)",
      17: 'Le nom de la table MySQL doit être transmis',
      18: 'Valeur non trouvée dans la base de données sélectionnée',
      19: 'Erreur lors du passage des paramètres clé / valeur',
      20: "Le format du fichier n'est pas autorisé",
      21: 'L\'enregistrement dans la base de données est de statut supprimé et ne peut pas être modifié',
      22: 'La limite de session pour votre adresse IP a été dépassée',
      23: 'Formulaire déjà soumis',
      24: 'E-mail non trouvé',
      25: 'Formulaire déjà soumis pour la période spécifiée',
      26: "Il n'est pas permis de modifier une date antérieure à 24 heures",
      27: "L'heure de début ne peut pas être la même ou antérieure à l'heure de fin",
      28: "L'heure saisie dépasse la plage horaire de travail pour ce jour",
      29: "Le temps de travail total dépasse la plage horaire de travail autorisée pour ce jour",
      30: "Les heures se chevauchent, il n'est pas possible d'effectuer l'entrée",
      31: "Il n'est pas autorisé de définir un groupe plus d'une fois dans l'année.",
      32: "Le salaire minimum est supérieur ou égal au salaire maximum.",
      33: "Fichier non trouvé sur le serveur / erreur de téléversement",
      34: "Entrée déjà approuvée pour cette date",
      35: "Impossible de trouver le barème",
      36: "La date de début doit être inférieure à la date de fin.",
      37: "Entrée impossible, l'employé n'est pas prévu pour travailler ce jour-là.",
      38: "La combinaison du groupe de chantier et de l'employé existe déjà.",
      39: "Le salarié a déjà saisi des heures de travail dans le système, il n'est pas possible de les supprimer",
      40: "Il est nécessaire de saisir correctement les heures de travail pour chaque site",
      41: "La combinaison sélectionnée de site et d'employé existe déjà dans l'un des groupes saisis",
      42: "La demande a été approuvée",
      43: "La demande a été annulée",
      44: "L'employé a déjà enregistré des heures de travail pour ce chantier et cette date",
      45: "La date de début doit être supérieure à la dernière date de travail",
      46: "La date de fin doit être inférieure au premier jour de retour",
      47: "Il existe déjà une entrée pour cette date, aucune autre modification n'est autorisée",
      48: "Il est uniquement possible de modifier les dates futures (demain et au-delà)",
      49: "Il n'est pas possible de saisir des heures de travail dans le futur."
    },
    custom: {}
  },

  [moduleNames.ADMIN_LOGIN_HISTORY]: {
    browserTabTitle: 'CRM - Admin | Login history',/* SHOULD_CHANGE */
  },



  [moduleNames.ADMIN_SPREADSHEETS]: {
    "modalFieldsErrors": modalFieldsErrors,
    "enumTranslations": enumTranslations,
    "commonTableFilters": commonTableFilters,
    "commonModalTranslations": commonModalTranslations,
    "commonTableTranslations": commonTableTranslations,
    "browserTabTitle": "CRM - Admin | Feuilles",
    "createLabel": "Ajouter",
    "deleteLabel": "Supprimer",
    "createModalTitle": "Créer",
    "deleteModalTitle": "Supprimer",
    "filters": {
      "type": { "label": "Taper" }
    },
    "columns": {
      "id": "ID",
      "type": "Taper",
      "url": "Télécharger",
      "status": "Statut",
      "created_at": "Créé",
      "name": "Nom",
    },
    "formData": {
      "type": { "label": "Taper" },
      "name": { "label": "Nom" },
      "year": { "label": "Année" },
      "trimester": { "label": "Trimestre" },
      "employees": { "label": "Employés" },
      company_name: { label: "Nom de l'entreprise" },
      company_address: { label: "Adresse de l'entreprise" },
      company_zip: { label: "Code postal de l'entreprise" },
      company_person_in_charge: { label: 'Responsable' },
    }
  },

  // Add this to the existing FR object in the file (assuming you have a similar structure)

  [moduleNames.ADMIN_COMPANIES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Entreprises',
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer une entreprise',
    editModalTitle: 'Modifier l\'entreprise',
    editModalBulkTitle: 'Modifier les entreprises',
    deleteBulkLabel: 'Supprimer les entreprises',
    deleteLabel: 'Supprimer l\'entreprise',
    deleteModalTitle: 'Supprimer l\'entreprise',
    deleteModalBulkTitle: 'Supprimer les entreprises',
    viewCompanyLabel: 'Voir l\'entreprise',
    filters: {
      name: { label: 'Nom' },
      note: { label: 'Note' },
      canton_id: { label: 'Canton', description: 'Rechercher par nom' },
      commune_id: { label: 'Commune', description: 'Rechercher par nom' }
    },
    columns: {
      'id': 'ID',
      'name': 'Nom',
      'note': 'Note',
      'canton.name': 'Canton',
      'commune.name': 'Commune',
      'updated_at': 'Modifié',
      'created_at': 'Créé'
    },
    formData: {
      name: { label: 'Nom' },
      canton_id: { label: 'Canton' },
      commune_id: { label: 'Commune' },
      note: { label: 'Note' }
    }
  },


  [moduleNames.ADMIN_USERS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Utilisateurs',/* DEVRAIT_CHANGER */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    authLabel: 'Auth',
    permissionsLabel: 'Permissions',
    deleteLabel: 'Supprimer',
    editBulkLabel: 'Modifier',
    deleteBulkLabel: 'Supprimer',
    createModalTitle: 'Créer un utilisateur',
    editModalTitle: 'Modifier l\'utilisateur',
    authModalTitle: 'Modifier le mot de passe de l\'utilisateur',
    permissionModalTitle: 'Permissions de l\'utilisateur',
    deleteModalTitle: 'Supprimer l\'utilisateur',
    deleteModalBulkTitle: 'Supprimer les utilisateurs',
    editModalBulkTitle: 'Modifier les utilisateurs',

    filters: {
      username: {
        label: 'Nom d\'utilisateur',
        description: 'Rechercher par nom d\'utilisateur',
      },
      email: {
        label: 'E-mail',
        description: 'Entrez l\'adresse e-mail complète',
      },
      first_name: {
        label: 'Prénom',
      },
      last_name: {
        label: 'Nom de famille',
      },
      status: {
        label: 'Statut',
      }
    },
    columns: {
      'info.id': 'ID',
      'data.username': 'Nom d\'utilisateur',
      'data.email': 'E-mail',
      'data.status': 'Statut',
      'data.first_name': 'Prénom',
      'data.last_name': 'Nom de famille',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé',
    },
    formData: {
      firstName: { label: 'Prénom' },
      lastName: { label: 'Nom de famille' },
      email: { label: 'E-mail' },
      status: { label: 'Statut' },
      password: { label: 'Mot de passe' },
      repeatPassword: { label: 'Répéter le mot de passe' },
    },
  },

  [moduleNames.ADMIN_EMPLOYEES_SINGLE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Employé',
    editLabel: 'Modifier',
    child: 'Enfant',
    noChildren: 'Aucun enfant ajouté',
    tabsGeneral: {
      employee: 'Employé',
      spouse: 'Conjoint',
      children: 'Enfants',
    },
    tabs: {
      general: 'Général',
      workingHours: 'Heures de travail'
    },
    sections: {
      personal: 'Personnel',
      addressPrimar: 'Adresse principale',
      addressSecundar: 'Adresse secondaire',
      businessInfo: 'Professionnel',
      salary: 'Salaire',
      files: 'Fichiers'
    },
    workingHours: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
      allowed_working_hours: 'Heures de travail autorisées',
      start_time: 'Heure de début',
      end_time: 'Heure de fin',
      day: 'Jour',
      noDataText: "Aucune heure de travail renseignée pour cet employé"
    },
    columns: {
      "info.id": "ID",
      "data.personal.employee_number": "Numéro d'employé",
      "data.personal.first_name": "Prénom",
      "data.personal.last_name": "Nom de famille",
      "data.personal.sex": "Genre",
      "data.personal.status": "Statut",
      "data.personal.email": "Email",
      "data.personal.phone": "Téléphone",
      "data.personal.date_of_birth": "Date de naissance",
      "data.personal.avs_number": "No.AVS",
      "data.personal.religion": "Religion",
      "data.personal.nationality": "Nationalité",
      "data.personal.has_children": "A des enfants",
      "data.personal.number_of_children": "Nombre d'enfants",
      "data.personal.marital_status": "État civil",
      "data.personal.date_of_marriage": "Date de mariage",
      "data.address_primar.address": "Adresse",
      "data.address_primar.city_extended.name": "Ville",
      "data.address_primar.commune_extended.name": "Commune",
      "data.address_primar.canton_extended.name": "Canton",
      "data.address_primar.country_extended.name": "Pays",
      "data.address_primar.contact_phone": "Téléphone de contact",
      "data.address_secundar.address": "Adresse",
      "data.address_secundar.city_extended.name": "Ville",
      "data.address_secundar.commune_extended.name": "Commune",
      "data.address_secundar.canton_extended.name": "Canton",
      "data.address_secundar.country_extended.name": "Pays",
      "data.address_secundar.contact_phone": "Téléphone de contact",
      "data.business_info.job_type": "Type de travail",
      "data.business_info.job_title": "Titre du poste",
      "data.business_info.key_number": "Numéro clé",
      "data.business_info.weekly_hours": "Heures hebdomadaires",
      "data.business_info.other_employer": "Autre employeur",
      "data.business_info.other_employer_rate": "Taux de l'autre employeur",
      "data.business_info.other_employer_start_date": "Date de début de l'autre employeur",
      "data.business_info.working_permit": "Permis de travail",
      "data.business_info.employment_date": "Date d'embauche",
      "data.business_info.resignation_date": "Date de démission",
      "data.business_info.working_site_extended.name": "Chantier",
      "data.salary.rate": "Taux",
      "data.salary.type": "Type",
      "data.salary.bank_account_number": "Numéro de compte bancaire",
      "data.salary.tax_canton_extended.name": "Canton fiscal",
      "data.salary.tax_country_extended.name": "Pays fiscal",
      "data.files.avs_card": "Carte AVS",
      "data.files.bank_details": "Détails bancaires",
      "data.files.identity_card": "Carte d'identité",
      "data.files.criminal_record": "Casier judiciaire",
      "data.files.external_prosecution_office": "Bureau des poursuites externe",
      "data.files.contract": "Le contrat",
      'data.spouse_personal.first_name': "Prénom",
      'data.spouse_personal.last_name': "Nom de famille",
      'data.spouse_personal.sex': "Genre",
      'data.spouse_personal.date_of_birth': "Date de naissance",
      'data.spouse_personal.avs_number': "No.AVS",
      'data.spouse_personal.religion': "Religion",
      'data.spouse_personal.has_children': "A des enfants",
      'data.spouse_personal.number_of_children': "Nombre d'enfants",
      'data.spouse_personal.marital_status': "État civil",
      'data.spouse_personal.date_of_marriage': "Date de mariage",
      'data.spouse_address_primar.address': "Adresse",
      'data.spouse_address_primar.city_extended.name': "Ville",
      'data.spouse_address_primar.commune_extended.name': "Commune",
      'data.spouse_address_primar.canton_extended.name': "Canton",
      'data.spouse_address_primar.country_extended.name': "Pays",
      'data.spouse_address_primar.contact_phone': "Téléphone de contact",
      'data.spouse_business_info.other_employer': "Autre employeur",
      'data.spouse_business_info.other_employer_rate': "Taux de l'autre employeur",
      'data.spouse_business_info.other_employer_start_date': "Date de début de l'autre employeur",
      'data.spouse_business_info.working_permit': "Permis de travail",
      "data.business_info.working_permit_expiration_date": "Expiration du permis de travail",
      'data.spouse_files.avs_card': "Carte AVS",
      'data.spouse_files.identity_card': "Carte d'identité",
      'personal.first_name': "Prénom",
      'personal.last_name': "Nom de famille",
      'personal.sex': "Genre",
      'personal.date_of_birth': "Date de naissance",
      'personal.nationality': "Nationalité",
      "address_primar.address": "Adresse",
      "address_primar.city_extended.name": "Ville",
      "address_primar.commune_extended.name": "Commune",
      "address_primar.canton_extended.name": "Canton",
      "address_primar.country_extended.name": "Pays",
      "address_primar.contact_phone": "Téléphone de contact",
    }
  },

  [moduleNames.ADMIN_EMPLOYEES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Employés',/* SHOULD_CHANGE */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer un employé',
    editModalTitle: 'Modifier l\'employé',
    editModalBulkTitle: 'Modifier les employés',
    viewEmployeeLabel: "Voir l'employé",
    personal: 'Personnel',
    business_info: 'Informations professionnelles',
    files: 'Des dossiers',
    child: 'Enfant',
    addressPrimar: 'Adresse principale',
    addressSecundar: 'Adresse secondaire',
    address: 'Addresse',
    deleteModalTitle: 'Supprimer l\'employé',
    deleteLabel: "Supprimer",
    getLink: "Obtenir le lien pour l'enregistrement des utilisateurs",
    linkModalTitle: "Obtenir le lien pour l'enregistrement des utilisateurs",
    successfullyUpdated: "Registrement réussi!",
    successText: "Merci! 🥳 Nous examinerons votre soumission sous peu.",
    filters: {
      company_id: { label: 'Entreprise' },
      email: { label: 'E-mail', description: 'Entrez l\'e-mail complet' },
      first_name: { label: 'Prénom' },
      last_name: { label: 'Nom de famille' },
      status: { label: 'Statut' },
      employeeNumber: { label: 'Numéro d\'employé' },
      sex: { label: 'Genre' },
      avs_number: { label: 'No.AVS' },
      has_children: { label: 'A des enfants' },
      marital_status: { label: 'État civil' },

    },
    columns: {
      'info.id': 'ID',
      'data.business_info.company_extended.name': 'Entreprise',
      'data.personal.status': 'Statut',
      'data.personal.employee_number': 'Numéro d\'employé',
      'data.personal.first_name': 'Prénom',
      'data.personal.last_name': 'Nom de famille',
      'data.personal.email': 'E-mail',
      'data.personal.no_avs': 'No. AVS',
      'data.personal.phone_number': 'Téléphone',
      'data.personal.sex': 'Genre',
      'data.personal.has_children': 'A des enfants',
      'data.personal.marital_status': 'État civil',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé'
    },
    formData: {
      status: { label: 'Statut' },
      employee_number: { label: 'Numéro d\'employé' },
      notes: { label: 'Notes' },
      personalFirstName: { label: 'Prénom' },
      personalLastName: { label: 'Nom de famille' },
      personalEmail: { label: 'E-mail' },
      personalPostalCode: { label: 'Code postal personnel' },
      personalNationality: { label: 'Nationalité' },
      personalNoAvs: { label: 'No.AVS' },
      personalDob: { label: 'Date de naissance' },
      personalMaritalStatus: { label: 'État civil' },
      personalReligion: { label: 'Religion' },
      personalHasChildren: { label: 'A des enfants?' },
      personalNumberOfChildren: { label: "Nombre d'enfants" },
      personalDateOfMarriage: { label: 'Date du mariage' },
      personalPhone: { label: 'Numéro de téléphone' },
      personalSex: { label: 'Genre' },
      allowedWorkingHours: { label: 'Heures de travail autorisées' },


      addressPrimarAddress: { label: 'Adresse' },
      addressSecundarAddress: { label: 'Adresse' },
      addressPrimarCity: { label: 'Ville' },
      addressSecundarCity: { label: 'Ville' },
      addressPrimarCountry: { label: 'Pays' },
      addressSecundarCountry: { label: 'Pays' },
      addressPrimarCanton: { label: 'Canton' },
      addressSecundarCanton: { label: 'Canton' },
      addressPrimarCommune: { label: 'Commune' },
      addressSecundarCommune: { label: 'Commune' },
      addressPrimarContactPhone: { label: 'Numéro du contact (si autre)' },
      addressSecundarContactPhone: { label: 'Numéro du contact (si autre)' },
      addressPrimarContactPhoneChild: { label: 'Numéro du contact' },

      businessInfoShowWorkingHours: { label: 'Afficher les heures de travail' },
      businessInfoSiteId: { label: 'Chantier' },
      businessInfoEmploymentDate: { label: "Date d'entre" },
      businessInfoResignationDate: { label: 'Date de sortir' },
      businessInfoJobTitle: { label: "Fonctionne dans l'entreprise" },
      businessInfoKeyNumber: { label: 'Numéro de clé' },
      businessInfoJobType: { label: "Type d'emploi" },
      businessInfoWeeklyHours: { label: "Nombre d'heures hebdomadaires" },
      businessInfoWorkingPermit: { label: 'Permis de travail' },
      businessInfoOtherEmployer: { label: "Autre employeur" },
      businessInfoOtherEmployerStartDate: { label: "Date de début chez l'autre employeur" },
      businessInfoWorkingPermitExpirationDate: { label: "Expiration du permis de travail" },

      salaryBankAccountNumber: { label: 'Numéro de compte bancaire' },
      salaryType: { label: 'Type de salaire' },
      salaryRate: { label: 'Taux de salaire' },
      salaryTaxCanton: { label: 'Canton fiscal' },
      salaryTaxCountry: { label: 'Pays fiscal' },

      monday: { label: 'Lundi' },
      tuesday: { label: 'Mardi' },
      wednesday: { label: 'Mercredi' },
      thursday: { label: 'Jeudi' },
      friday: { label: 'Vendredi' },
      saturday: { label: 'Samedi' },
      sunday: { label: 'Dimanche' },
      freeDay: { label: 'Jour libre' },
      startTime: { label: 'Heure de début' },
      endTime: { label: 'Heure de fin' },
      totalAllowedHours: { label: 'Heures totales autorisées' },

      fileAvsCard: { label: 'Carte AVS' },
      fileBankDetails: { label: 'Coordonnées bancaires' },
      fileIdentityCard: { label: "Carte d'identité" },
      fileCriminalRecord: { label: 'Casier judiciaire' },
      fileExternalProsecutionOffice: { label: 'Office des poursuites' },
      fileContract: { label: 'Le contrat' },

      spousePersonalFirstName: { label: 'Prénom' },
      spousePersonalLastName: { label: 'Nom de famille' },
      spousePersonalNoAvs: { label: 'No.AVS' },
      spousePersonalDob: { label: 'Date de naissance' },
      spousePersonalMaritalStatus: { label: 'État civil' },
      spousePersonalReligion: { label: 'Religion' },
      spousePersonalHasChildren: { label: 'A des enfants?' },
      spousePersonalNumberOfChildren: { label: "Nombre d'enfants" },
      spousePersonalDateOfMarriage: { label: 'Date du mariage' },
      spousePersonalSex: { label: 'Genre' },

      spouseAddressPrimarAddress: { label: 'Adresse' },
      spouseAddressPrimarCity: { label: 'Ville' },
      spouseAddressPrimarCountry: { label: 'Pays' },
      spouseAddressPrimarCanton: { label: 'Canton' },
      spouseAddressPrimarCommune: { label: 'Commune' },
      spouseAddressPrimarContactPhone: { label: 'Numéro du contact' },

      spouseBusinessInfoWorkingPermit: { label: 'Permis de travail' },
      spouseBusinessInfoOtherEmployer: { label: "Autre employeur" },
      spouseBusinessInfoOtherEmployerRate: { label: "Taux de l'autre employeur" },
      spouseBusinessInfoOtherEmployerStartDate: { label: "Date de début chez l'autre employeur" },

      spouseFileAvsCard: { label: 'Carte Avs' },
      spouseFileIdentityCard: { label: "Carte d'identité" },

      children: { label: 'Enfants' },
      primar: { label: 'Principale' },
      secundar: { label: 'Secondaire' }
    },
    tabs: {
      personal: 'Personnel',
      address: 'Adresse',
      shipping: 'Livraison',
      professional: 'Professionnel',
      salary: 'Salaire',
      required: 'Obligatoire',
      files: 'Des dossiers',
      workingHours: 'Heures de travail',
      spouse: 'Conjointe',
      children: 'Enfants'
    }
  },

  [moduleNames.ADMIN_EMPLOYEES_ABSENCE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Absences des employés', /* DOIT CHANGER */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer une absence',
    editModalTitle: 'Modifier l\'absence',
    editModalBulkTitle: 'Modifier les absences',
    deleteBulkLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer l\'absence',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer l\'absence',
    deleteModalBulkTitle: 'Supprimer les absences',
    filters: {
      employee_id: { label: 'Employé' },
      start_date: { label: 'Dernier jour de travail' },
      end_date: { label: 'Premier jour de travail' },
      month: { label: 'Mois' },
      year: { label: 'Année' },
      type: { label: 'Taper' },
    },
    columns: {
      'info.id': 'ID',
      'data.start_date': 'Date de début',
      'data.end_date': 'Date de fin',
      'data.last_day_of_work': 'Dernier jour de travail',
      'data.first_day_back': 'Premier jour de travail',
      'data.employee.number': 'Numéro de l\'employé',
      'data.employee.first_name': 'Prénom',
      'data.employee.last_name': 'Nom de famille',
      'data.type': 'Taper',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé',
    },
    formData: {
      startDate: { label: 'Date de début' },
      endDate: { label: 'Date de fin' },
      lastDayOfWork: { label: 'Dernier jour de travail' },
      firstDayOfWork: { label: 'Premier jour de travail' },
      type: { label: 'Taper' },
      employee_id: { label: 'Employé' },
    },
  },

  [moduleNames.ADMIN_EMPLOYEES_NOTES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Notes des employés',/* SHOULD_CHANGE */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer une note',
    editModalTitle: 'Modifier une note',
    editModalBulkTitle: 'Modifier les notes',
    deleteBulkLabel: 'Supprimer les notes',
    deleteModalTitle: 'Supprimer la note',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer la note',
    deleteModalBulkTitle: 'Supprimer les notes',
    filters: {
      employee_id: { label: 'Employé' },
      created_user_id: { label: 'Créé par', description: "Rechercher par nom d'utilisateur" },
    },
    columns: {
      'info.id': 'ID',
      'info.employee.first_name': 'Prénom',
      'info.employee.last_name': 'Nom de familie',
      'info.created_user_username': 'Créé par',
      'created.timestamp': 'Créé',
      'data.note': 'Note',
    },
    formData: {
      employee_id: { label: 'Employé' },
      note: { label: 'Note' },
    },
  },

  [moduleNames.ADMIN_WORKING_SITES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Chantiers',/* SHOULD_CHANGE */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    deleteLabel: 'Supprimer',
    editBulkLabel: 'Modifier',
    deleteBulkLabel: 'Supprimer',
    createModalTitle: 'Ajouter un chantier',
    editModalTitle: 'Modifier le chantier',
    deleteModalTitle: 'Supprimer le chantier',
    deleteModalBulkTitle: 'Supprimer les chantiers',
    editModalBulkTitle: 'Modifier les chantiers',
    filters: {
      city: {
        label: 'Ville',
      },
      phone: { label: 'Téléphone' },
      name: { label: 'Nom' },
      status: { label: 'Statut' },
    },
    columns: {
      'info.id': 'ID',
      'data.name': 'Nom',
      'info.city.name': 'Ville',
      'data.phone': 'Téléphone',
      'data.address': 'Adresse',
      'data.contact_person': 'Personne de contact',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé',
      'data.status': 'Statut',
    },
    formData: {
      name: { label: 'Nom' },
      city: { label: 'Ville' },
      address: { label: 'Adresse' },
      contact_person: { label: 'Personne de contact' },
      phone: { label: 'Téléphone' },
      status: { label: 'Statut' },
    }
  },

  [moduleNames.ADMIN_TAX_SCALES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Barèmes',
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer un barème',
    editModalTitle: 'Modifier le barème',
    editModalBulkTitle: 'Modifier les barèmes',
    deleteBulkLabel: 'Supprimer les barèmes',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer le barème',
    deleteModalBulkTitle: 'Supprimer les barèmes',
    duplicateLabel: 'Dupliquer',
    duplicateModalTitle: 'Dupliquer',
    duplicateModalBody: 'Êtes-vous sûr de vouloir dupliquer cet enregistrement ?',
    detailsLabel: 'Détails',
    absences: {
      vacancy: 'V',
      leave: 'C',
      'public-holidays': 'F',
      diseases: 'M',
      accidents: 'A',
      default: 'D'
    },
    filters: {
      name: { label: 'Nom' },
      group: { label: 'Groupe' },
      year: { label: 'Année' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Nom',
      'info.group': 'Groupe',
      'info.year': 'Année',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé'
    },
    formData: {
      name: { label: 'Nom' },
      group: { label: 'Groupe' },
      year: { label: 'Année' },
    },
  },

  [moduleNames.ADMIN_TAX_SCALES_DETAILS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Détails des barémes',
    createLabel: 'Ajouter',
    editLabel: 'Éditer',
    editBulkLabel: 'Éditer en masse',
    createModalTitle: 'Créer',
    editModalTitle: 'Éditer',
    editModalBulkTitle: 'Éditer',
    deleteBulkLabel: 'Supprimer les barémes',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer',
    deleteModalBulkTitle: 'Supprimer',
    addNewRow: 'Ajouter',
    detailsFor: 'Détails pour',
    useDecimalNotice: "Veuillez utiliser , au lieu de . pour les séparateurs décimaux",
    filters: {
      min_salary: { label: 'Min salaire' },
      max_salary: { label: 'Max salaire' },
    },
    columns: {
      'info.id': 'ID',
      'data.min_salary': 'Min salaire',
      'data.max_salary': 'Max salaire',
      'data.children.0': 'Sans enfant',
      'data.children.1': 'Enfant 1',
      'data.children.2': 'Enfant 2',
      'data.children.3': 'Enfant 3',
      'data.children.4': 'Enfant 4',
      'data.children.5': 'Enfant 5',
      'data.children.6': 'Enfant 6',
      'data.children.7': 'Enfant 7',
      'data.children.8': 'Enfant 8',
    },
    formData: {
      min_salary: { label: 'Min salarie*' },
      max_salary: { label: 'Max salarie*' },
      0: { label: 'Enfant 1' },
      1: { label: 'Enfant 2' },
      2: { label: 'Enfant 3' },
      3: { label: 'Enfant 4' },
      4: { label: 'Enfant 5' },
      5: { label: 'Enfant 6' },
      6: { label: 'Enfant 7' },
      7: { label: 'Enfant 8' },
      child0: { label: 'Enfant 1' },
      child1: { label: 'Enfant 2' },
      child2: { label: 'Enfant 3' },
      child3: { label: 'Enfant 4' },
      child4: { label: 'Enfant 5' },
      child5: { label: 'Enfant 6' },
      child6: { label: 'Enfant 7' },
      child7: { label: 'Enfant 8' },
    },
  },

  [moduleNames.ADMIN_TAX_EMPLOYEES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Décompte fiscal',
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier en masse',
    createModalTitle: 'Créer',
    editModalTitle: 'Modifier',
    getLabel: 'Obtenir',
    editModalBulkTitle: 'Modifier en masse',
    deleteBulkLabel: 'Supprimer en masse',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer',
    additionalInfoModal: {
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      employeeNumber: 'Numéro d\'employé',
      taxScale: 'Barème',
      numberOfChildren: 'Nombre d\'enfants'
    },
    filters: {
      year: { label: 'Année' },
      trimester: { label: 'Trimestre' },
      status: { label: 'Statut' },
      employee_number: { label: 'Numéro d\'employé' },
      employee_id: { label: 'Employé', description: 'Recherche par prénom' }
    },
    columns: {
      'id': 'ID',
      'year': 'Année',
      'trimester': 'Trimestre',
      'status': 'Statut',
      'created_at': 'Créé à',
      'created_by': 'Créé par',
      'file_url': 'Fichier',
    },
    formData: {
      year: { label: 'Année' },
      trimester: { label: 'Trimestre' },
      employees: { label: 'Employés' },
      order_number: { label: 'Numéro de commande' },
      company_name: { label: "Nom de l'entreprise" },
      company_address: { label: "Adresse de l'entreprise" },
      company_zip: { label: "Code postal de l'entreprise" },
      company_person_in_charge: { label: "Responsable de l'entreprise" }
    },
  },

  [moduleNames.ADMIN_WORKING_HOURS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Heures de travail annuelles',
    createLabel: 'Ajouter',
    createModalTitle: 'Créer',
    editLabel: 'Éditer',
    editModalTitle: 'Éditer',
    editBulkLabel: 'Éditer',
    totalsLabel: 'Totale',
    addNewRow: 'Ajouter une nouvelle ligne',
    start_time: "Heure de début",
    end_time: "Heure de fin",
    filters: {
      employee_id: { label: 'Employé' },
      year: { label: 'Année' },
    },
    columns: {
      "day": "Jour",
      "months.january": "Janvier",
      "months.february": "Février",
      "months.march": "Mars",
      "months.april": "Avril",
      "months.may": "Mai",
      "months.june": "Juin",
      "months.july": "Juillet",
      "months.august": "Août",
      "months.september": "Septembre",
      "months.october": "Octobre",
      "months.november": "Novembre",
      "months.december": "Décembre",
    },
    formData: {
      supposed_working_hours: { label: 'Heures de travail prévues' },
      date: { label: 'Date' },
      note: { label: 'Commentaire' }
    },
    absences: {
      vacancy: 'V',
      leave: 'C',
      'public-holidays': 'F',
      diseases: 'M',
      accidents: 'A',
      default: 'D'
    }
  },

  [moduleNames.ADMIN_WORKING_HOURS_TOTALS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Total des heures de travail', /* À CHANGER */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editModalTitle: 'Modifier',
    editBulkLabel: 'Modifier',
    totalsLabel: 'Totals',
    detailsFor: 'Total pour',
    formData: {
      supposed_working_hours: { label: 'Heures de travail prévues' }
    },
    columns: {
      "month": "Mois",
      "total_working_hours": "Horaires de travail",
      "total_supposed_working_hours": "Horaires de travail supposés",
      "total_hours_difference": "Différence",
      "total_earned": "Salaire payé",
      "total_holidays": "Fériés pris",
      "total_vacations": "Vacances prises",
      "remaining_vacations": "Vacances restantes",
      "totals": 'Totale',
    },
    absences: {
      vacancy: 'V',
      leave: 'C',
      'public-holidays': 'F',
      diseases: 'M',
      accidents: 'A',
      default: 'D'
    }
  },

  [moduleNames.ADMIN_WORKING_HOURS_SUBMISSIONS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    additionalInfoLabel: "Plus d'informations",
    browserTabTitle: 'CRM - Administration | Heures de travail',/* DEVRAIT_CHANGER */
    editLabel: 'Modifier',
    editModalTitle: 'Modifier les heures de travail',
    filters: {
      date: {
        label: 'Date',
      },
      month: {
        label: 'Mois'
      },
      year: {
        label: 'Année',
      },
      employee_id: {
        label: 'Employé',
        description: 'Recherche par prénom'
      },
      start_time: {
        label: 'Heure de début',
      },
      end_time: {
        label: 'Heure de fin',
      },
      working_time: {
        label: 'Total des heures',
      },
    },
    formData: {
      status: { label: 'Statut' }
    },
    columns: {
      'id': 'ID',
      'employee_number': 'Numéro d\'employé',
      'first_name': 'Prénom',
      'last_name': 'Nom de famille',
      'date': 'Date',
      'start_time': 'Heure de début',
      'end_time': 'Heure de fin',
      'comments': 'Commentaire',
      'working_time': 'Total des heures',
      'status': 'Statut',
      'notes': 'Note',
    },
    additionalInfoModal: {
      totalWorkingHours: 'Total des heures de travail de la journée',
      workingSite: 'Chantier',
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      workingTime: 'Total des heures',

    }
  },

  [moduleNames.ADMIN_COMMUNE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Communes', /* À CHANGER */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer une commune',
    editModalTitle: 'Modifier une commune',
    editModalBulkTitle: 'Modifier les communes',
    viewCommuneLabel: 'Voir la commune',
    deleteBulkLabel: 'Supprimer les communes',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer la commune',
    deleteModalBulkTitle: 'Supprimer les communes',
    filters: {
      name: { label: 'Nom' },
      canton_id: { label: 'Canton' },
      language: { label: 'Langue' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Nom',
      'info.canton.name': 'Canton',
      'info.canton.postal_code': 'Code postal',
      'info.canton.code': 'Code de canton',
      'info.language': 'Langue',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé'
    },
    formData: {
      name: { label: 'Nom' },
      canton_id: { label: 'Canton' },
      language: { label: 'Langue' },
    },
  },

  [moduleNames.ADMIN_CANTONS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Cantons', /* À CHANGER */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer un canton',
    editModalTitle: 'Modifier un canton',
    editModalBulkTitle: 'Modifier les cantons',
    deleteBulkLabel: 'Supprimer les cantons',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer le canton',
    deleteModalBulkTitle: 'Supprimer les cantons',
    filters: {
      name: { label: 'Nom' },
      postal_code: { label: 'Code postal' },
      code: { label: 'Code de canton' },
      country_id: { label: 'Pays' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Nom',
      'info.country_id': 'Pays',
      'info.postal_code': 'Code postal',
      'info.code': 'Code de canton',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé'
    },
    formData: {
      name: { label: 'Nom' },
      postal_code: { label: 'Code postal' },
      code: { label: 'Code de canton' },
      country_id: { label: 'Pays' }
    },
  },

  [moduleNames.ADMIN_CITIES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Cities', /* À CHANGER */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer une ville',
    editModalTitle: 'Modifier une ville',
    editModalBulkTitle: 'Modifier les villes',
    deleteBulkLabel: 'Supprimer les villes',
    deleteLabel: 'Supprimer',
    deleteModalTitle: 'Supprimer la ville',
    filters: {
      name: { label: 'Nom' },
      canton_id: { label: 'Canton' },
      commune_id: { label: 'Commune' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Nom',
      'info.canton_name': 'Canton',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé'
    },
    formData: {
      name: { label: 'Nom' },
      canton_id: { label: 'Canton' },
      communes: { label: 'Communes' },
    },
  },

  [moduleNames.ADMIN_CANTONS_HOLIDAYS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Administration | Vacances dans les cantons',
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',
    createModalTitle: 'Créer',
    editModalTitle: 'Modifier les vacances',
    editModalBulkTitle: 'Modifier les vacances',
    deleteLabel: 'Supprimer',
    deleteBulkLabel: 'Supprimer les vacances',
    deleteModalTitle: 'Supprimer les vacances',
    deleteModalBulkTitle: 'Supprimer les vacances',
    filters: {
      name: { label: 'Nom' },
      date_range: { label: 'Plage de dates' },
      canton_id: { label: 'Canton' }
    },
    columns: {
      'info.id': 'ID',
      'info.name': 'Nom',
      'info.start_date': 'Date de début',
      'info.end_date': 'Date de fin',
      'info.cantons.name': 'Canton',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé'
    },
    formData: {
      name: { label: 'Nom' },
      canton_id: { label: 'Canton' },
      start_date: { label: 'Date de début' },
      end_date: { label: 'Date de fin' },
    },
  },

  [moduleNames.ADMIN_WORKING_HOURS_ANNUAL]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Heures de travail annuelles',/* SHOULD_CHANGE */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    editBulkLabel: 'Modifier',

    absences: {
      vacancy: 'V',
      leave: 'C',
      'public-holidays': 'F',
      diseases: 'M',
      accidents: 'A',
      default: 'D'
    }
  },

  [moduleNames.ADMIN_FORMS_TEMPLATES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Modèles de formulaires',/* SHOULD_CHANGE */
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    deleteLabel: 'Supprimer',
    editBulkLabel: 'Modifier',
    getLinkLabel: 'Obtenir le lien',
    getLinkModalLabel: 'Obtenir le lien',
    deleteBulkLabel: 'Supprimer',
    createModalTitle: 'Ajouter un modèle',
    editModalTitle: 'Modifier le modèle',
    deleteModalTitle: 'Supprimer le modèle',
    deleteModalBulkTitle: 'Supprimer les modèles',
    filters: {
      name: {
        label: 'Nom',
      },
      description: {
        label: 'Description',
      },
      status: {
        label: 'Statut',
      },
    },
    columns: {
      'info.id': 'ID',
      'data.name': 'Nom',
      'data.description': 'Description',
      'info.status': 'Statut',
      'data.expires': 'Expire',
      'data.target': 'Cible',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé',
    },
    formData: {
      name: { label: 'Nom' },
      description: { label: 'Description' },
      fields: { label: 'Champs' },
      target: { label: 'Cible' },
      expires: { label: 'Expire' },
      addQuestionText: 'Ajouter une question',
      fields: {
        'input': 'Entrée de texte',
        'select-single': 'Menu déroulant',
        'select-multiple': 'Menu déroulant avec sélection multiple',
        'date': 'Date',
        'time-range': 'Plage horaire',
        'time': 'Heure',
        'radio': 'Sélection unique',
        'checkbox': 'Case à cocher (sélection multiple)',
        'question': 'Question',
        'required': 'Obligatoire',
        'addAnOption': 'Ajouter une option',
        'options': 'Options',
        'selectList': 'Sélectionner une liste'
      }
    }
  },

  [moduleNames.ADMIN_FORMS_SUBMISSIONS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Soumissions de formulaires',/* SHOULD_CHANGE */
    viewLabel: 'Voir',
    viewTitle: 'Voir les réponses',
    filters: {
      email: {
        label: 'E-mail',
        description: 'Entrez l\'adresse e-mail complète',
      },
      target: {
        label: 'Cible',
      },
    },
    columns: {
      'info.id': 'ID',
      'data.email': 'E-mail',
      'data.first_name': 'Prénom',
      'data.last_name': 'Nom de famille',
      'data.target': 'Cible',
      'created.timestamp': 'Créé',
    }
  },

  [moduleNames.ADMIN_PROFILE]: {
    modalFieldsErrors,
    browserTabTitle: 'CRM - Profil', /* SHOULD_CHANGE */
    profileGeneralSettings: 'Paramètres généraux du profil',
    profileAuthSettings: 'Paramètres d\'authentification du profil',
    general: 'Général',
    changePassword: 'Changer le mot de passe',
    password: 'Mot de passe',
    repeatPassword: 'Répéter le mot de passe',
    saveChanges: 'Enregistrer les modifications',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    successfullyUpdated: 'Mise à jour réussie !'
  },

  [moduleNames.ADMIN_WORKING_SITES_PLANNER]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    working_hours: 'Heures de travail',
    addNewRow: 'Ajouter une nouvelle ligne',
    editModalTitle: 'Modifier',
    total: 'Totale',
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche",
    "createModalTitle": "Créer une constante",
    "createLabel": "Créer",
    createModalInfo: "Créez un planificateur constant. Si vous sélectionnez date : 07/07/2024 (dimanche), type de récurrence : hebdomadaire, intervalle : 1, durée : cette année - La soumission s'appliquerait pour tous les dimanches de cette année, à partir du 07/07/2024",
    groupAdd: "Ajouter un groupe",
    individualAdd: "Ajouter individuellement",
    infoModalTitle: "Informations pour",
    name: 'Nom',
    workingSite: 'Chantier',
    time: 'Temps',
    deleteLabel: "Supprimer",
    deleteModalTitle: "Supprimer",
    deleteModalInfo: "Supprimer les entrées du planificateur. Ex : si vous sélectionnez la date : 07/07/2024 (dimanche), type de récurrence : hebdomadaire, intervalle : 1, durée : cette année - La soumission s'appliquerait à chaque dimanche de cette année, à partir du 07/07/2024",
    totalHoursWorked: "Total d'heures travaillées",
    totalHoursToWork: "Total d'heures de travail",
    filters: {
      employee_id: { label: 'Employé' },
      date: { label: 'Date' },
      group_id: { label: 'Groupe' },
      working_site_id: { label: 'Site de travail' },
      employeeNumber: { label: 'Numéro d\'employé' },
      company_id: { label: 'Entreprise' }
    },
    formData: {
      site_data: { label: 'Site data' },
      date: { label: "Date de début" },
      recurrence_type: { label: "Type de récurrence" },
      interval: { label: "Intervalle" },
      duration: { label: "Durée" },
      dayOfWeek: { label: "Jour de la semaine" },
      weekOfMonth: { label: "Semaine du mois" }
    }
  },

  [moduleNames.ADMIN_GROUPS]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | Groupes',
    createLabel: 'Ajouter',
    editLabel: 'Modifier',
    authLabel: 'Auth',
    deleteLabel: 'Supprimer',
    editBulkLabel: 'Modifier',
    deleteBulkLabel: 'Supprimer',
    createModalTitle: 'Créer groupe',
    editModalTitle: 'Modifier groupe',
    deleteModalTitle: 'Supprimer groupe',
    deleteModalBulkTitle: 'Supprimer groupes',
    filters: {
      employee: { label: 'Employé' },
      working_site: { label: 'Site de travail' },
      label: { label: "Label" }
    },
    columns: {
      'info.id': 'ID',
      'data.label': 'Label',
      'data.employees': 'Employés',
      'data.employees_count': 'Employés #',
      'data.working_sites': 'Chantiers',
      'data.working_sites_count': 'Chantiers #',
      'edited.timestamp': 'Modifié',
      'created.timestamp': 'Créé',
    },
    formData: {
      label: { label: 'Label' },
      employees: { label: 'Employés' },
      working_sites: { label: 'Chantiers' },
    }
  },

  [moduleNames.ADMIN_REPORT_EMPLOYEES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | rapport employés',
    filters: {
      employee: { label: 'Employé' },
      month: { label: 'Mois' },
      year: { label: 'Année' },
    },
    columns: {
      'day': 'Jour',
      'site_name': 'Chantier',
    }
  },

  [moduleNames.ADMIN_REPORT_WORKING_SITES]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | rapport chantiers',
    hoursWorked: 'Heures travaillées',
    plannedHours: 'Heures prévues pour travailler',
    filters: {
      month: { label: 'Mois' },
      year: { label: 'Année' },
      working_site: { label: 'Chantier' },
    },
    columns: {
      'date': 'Date',
    }
  },

  [moduleNames.ADMIN_REPORT_WORK_TABLE]: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: 'CRM - Admin | rapport pivot',
    filters: {
      month: { label: 'Mois' },
      year: { label: 'Année' },
      employee: { label: 'Employé' },
    },
    columns: {
      'employee_name': 'Employé',
    }
  },

  workingHoursWeb: {
    modalFieldsErrors,
    enumTranslations,
    workingHoursFor: 'Heures de travail pour',
    selectDate: 'Sélectionner une date',
    workingSite: 'Chantier',
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    remove: 'Supprimer',
    totalHoursWorked: 'Total des heures de travail de la journée',
    note: 'Commentaire',
    comment: 'Autres activités',
    reset: 'Réinitialiser',
    save: 'Enregistrer',
    addAnotherRow: 'Ajouter une autre ligne',
    logOut: 'Se déconnecter',
    pleaseEnterEmployeeNumber: "Veuillez saisir votre numéro d'employé",
    enterEmployeeNumber: "Saisir le numéro d'employé",
    submit: 'Soumettre',
    fillOutFields: 'Veuillez remplir tous les champs.',
    successfullyUpdated: "Registrement réussi!"
  },

  webPlanner: {
    modalFieldsErrors,
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    working_hours: 'Heures de travail',
    addNewRow: 'Ajouter une nouvelle ligne',
    total: 'Totale',
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche",
    filters: {
      date: { label: 'Date' },
    }
  }
}

export default FR;